export const SET_PAYMENT_METHODS = 'app/Payment/SET_PAYMENT_METHODS';
export const SET_VIOLATION = 'app/Payment/SET_VIOLATION';
export const CLEAR_VIOLATIONS = 'app/Payment/CLEAR_VIOLATIONS';
export const CLEAR_ERROR_MESSAGE = 'app/Payment/CLEAR_ERROR_MESSAGE';
export const SUBMIT_PAYMENT_REQUEST = 'app/Payment/SUBMIT_PAYMENT_REQUEST';
export const SUBMIT_PAYMENT_COMPLETE = 'app/Payment/SUBMIT_PAYMENT_COMPLETE';
export const SET_PAYMENT_ERROR = 'app/Payment/SET_PAYMENT_ERROR';
export const CLEAR_PAYMENT_ERROR = 'app/Payment/CLEAR_PAYMENT_ERROR';
